import styled from 'styled-components';

import calLeftImg from 'images/cal_left.png'
import calRightImg from 'images/cal_right.png'
export const Calendararea = styled.div`

    & {
      background : #fff;
    }
    
    & .DayPicker {
        width : 100%;
    }
    & .DayPicker-Day {
        font-size: calc(100vw*(11/375));
        font-weight: 500;
        padding: .9em 1.6em;
    }
    & .DayPicker-wrapper {
        padding-bottom :calc(100vw*(5/375));
    }
    & .DayPicker-Month {
        margin : 0;
    }
    & .DayPicker-NavButton--next {
        position: absolute;
        top: calc(100vw*(8/375));
        right: calc(100vw*(115/375));
        width: calc(100vw*(7/375));
        height: calc(100vw*(12/375));
        background-image : url(${calRightImg});
        background-repeat: no-repeat;
        background-size : calc(100vw*(7/375)) calc(100vw*(12/375));
    }
    & .DayPicker-NavButton--prev {
        position: absolute;
        top: calc(100vw*(8/375));
        left: calc(100vw*(115/375));
        width: calc(100vw*(7/375));
        height: calc(100vw*(12/375));
        background-image : url(${calLeftImg});
        background-repeat: no-repeat;
        background-size : calc(100vw*(7/375)) calc(100vw*(12/375));
    }
    & .DayPicker-Caption {
        margin-bottom:  calc(100vw*(12/375));
        padding: calc(100vw*(6.5/375)) 0 0 0;
        text-align: center;
    }
    & .DayPicker-Caption > div {
        text-align: center;
        font-size: calc(100vw*(14/375));
        font-weight: 500;
        display: inline-block;
    }
    & .DayPicker-Caption > div:first-child {
        margin-right: calc(100vw*(3/375));
    }
    & .DayPicker-Body > div:first-child > div {
        padding: 0.2em 1em .9em 1em;
        &::after {
            top:40%;
        }
    }
    & .DayPicker-Weekday abbr[title] {
        font-size: calc(100vw*(10/375));
        font-weight: 500;
        color: #ffc036;
    }
    & .DayPicker-Day--today:not(.DayPicker-Day--selected){
      position:relative;
      color: white;
      z-index:2
    }
    & .DayPicker-Day--today:not(.DayPicker-Day--selected)::after {
      content: ' ';
      background-color: #eaeaea;
      color: #4e4e4e;   
      height: calc(100vw*(33/375));
      width: calc(100vw*(33/375));
      position: absolute;
      border-radius: 50%;
      top: 50%;
      left: 50%;
      z-index: -1;
      transform: translate(-50%, -50%);
    }

    & .DayPicker-Day {
      border-radius: 0;
    }
    & .DayPicker-Day--start:not(.DayPicker-Day--hiderange):not(.DayPicker-Day--outside).DayPicker-Day--selected:before {
      content: " ";
      background: linear-gradient(to right, transparent 50%, #FFEFCE 50%);
      height: calc(100vw*(25/375));
      position: absolute;
      z-index: -2;
      width: 100%;
      top: 0;
      left: 0;
      bottom: 0;
      margin: auto;
    }
    & .DayPicker-Day--end:not(.DayPicker-Day--hiderange):not(.DayPicker-Day--outside).DayPicker-Day--selected:before {
      content: " ";
      background: linear-gradient(to right, #FFEFCE 50%, transparent 50%);
      height: calc(100vw*(25/375));
      position: absolute;
      z-index: -2;
      width: 100%;
      top: 0;
      left: 0;
      bottom: 0;
      margin: auto;
    }
    & .DayPicker-Day--start:not(.DayPicker-Day--outside):after,
    & .DayPicker-Day--end:not(.DayPicker-Day--outside):after {
      content: " ";
      border-radius: 50%;
      background-color: #FFCF19;
      height: calc(100vw*(33/375));
      width: calc(100vw*(33/375));
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: -1;
      transform: translate(-50%, -50%);
    }

    &#calendar-month-range-picker-section .DayPicker-Day--selected{
      position : relative;
      background: transparent;

      z-index: 2;
    }

    & .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
      color: #121212;
    }

    & .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside):after
    {
      content: '';
      background-color: #FFEFCE !important;
      color: #4e4e4e;
      width: 100%;
      height: calc(100vw*(25/375));
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: -1;
      transform: translate(-50%, -50%);
    }
`